import store from '@/store/index.js';

export const ifNotAuthenticated = (to, from, next) => {
    // Redirect to default page
    if (store.getters.isAuthenticated) {
        next({ name: 'orders' });
        return;
    }

    next();
};

export const ifAuthenticated = (to, from, next) => {
    // Redirect to login
    if (!store.getters.isAuthenticated) {
        next({ name: 'auth.login' });
        return;
    }

    next();
};

export const mustChangePassword = (to, from, next) => {
    // Redirect to default page
    if (!store.getters.mustChangePassword) {
        next({ name: 'orders' });
        return;
    }

    next();
};
